const editor = {
  toolbar: 'Toolbar',
  content_area: 'Main content area, start typing to enter text.',
  back: 'Back',
  undo: 'Undo',
  redo: 'Redo',
  heading: 'Heading',
  heading_format: 'Format text as heading',
  heading_level: 'Heading {{level}}',
  list: 'List',
  list_options: 'List options',
  bullet_list: 'Bullet List',
  ordered_list: 'Ordered List',
  task_list: 'Task List',
  blockquote: 'Blockquote',
  code_block: 'Code Block',
  bold: 'Bold',
  italic: 'Italic',
  strike: 'Strike',
  code: 'Code',
  underline: 'Underline',
  text_color: 'Text color',
  text_color_palette: 'Text color palette',
  text_color_value: '{{color}} text color',
  text_color_default: 'Default text color',
  text_color_custom: 'Custom text color',
  text_color_black: 'Black',
  text_color_gray: 'Gray',
  text_color_red: 'Red',
  text_color_blue: 'Blue',
  text_color_green: 'Green',
  text_color_orange: 'Orange',
  superscript: 'Superscript',
  subscript: 'Subscript',
  align_left: 'Align left',
  align_center: 'Align center',
  align_right: 'Align right',
  align_justify: 'Align justify',
  highlight: 'Highlight',
  highlight_text: 'Highlight text',
  highlight_colors: 'Highlight colors',
  highlight_color: '{{color}} highlight color',
  remove_highlight: 'Remove highlight',
  color_default: 'Default background',
  color_gray: 'Gray background',
  color_brown: 'Brown background',
  color_orange: 'Orange background',
  color_yellow: 'Yellow background',
  color_green: 'Green background',
  color_blue: 'Blue background',
  color_purple: 'Purple background',
  color_pink: 'Pink background',
  color_red: 'Red background',
  link: 'Link',
  link_placeholder: 'Paste a link...',
  link_apply: 'Apply link',
  link_open: 'Open in new window',
  link_remove: 'Remove link',
  search_replace: 'Search and replace',
  previous_result: 'Previous result',
  next_result: 'Next result',
  close: 'Close',
  search: 'Search',
  replace: 'Replace',
  replace_all: 'Replace all',
  replace_current_result: 'Replace current result',
  replace_all_results: 'Replace all results',
  match_case: 'Match case',
  whole_words: 'Whole words',
  use_regex: 'Use regular expression',
  try_search_pattern: 'Try a search pattern',
  regex_any_middle_letter: 'Any middle letter:',
  regex_either_term: 'Either term:',
  regex_case_c: 'Uppercase or lowercase C:',
  try_search_replace: 'Try search and replace',
  replace_with: 'to',
  regex_docs: 'Learn about regular expressions',
}

export default editor
